import { Component, ViewEncapsulation, Inject, ViewChild } from "@angular/core";
import { BaseComponent } from "../../shared";

@Component({
  templateUrl: './searchInfoComponent.html'
})
export class SearchInfoComponent extends BaseComponent {

  
}